import React, { Component } from 'react';
import Presenter from './presenter';
import View from './view';
import Model from './model';

export default class Landing extends Component {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      new Model(this, {
        consent: false,
        consentError: undefined,
        tab: 'main',
        upgradeName: '',
        upgradeFqdn: '',
        publisherConsent: '',
        upgradeCaptcha: '',
        publisherConsentError: undefined,
        loading: undefined,
        errorName: undefined,
        errorFqdn: undefined,
        errorCaptcha: undefined,
        token: null,
        password: '',
        errorPassword: undefined,
      })
    );
  }

  componentDidMount() {
    this.presenter.onAttach();
  }

  render() {
    return <View {...this.state} presenter={this.presenter} />;
  }
}
